import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Activity } from "lucide-react";

export const Route = createFileRoute("/admin/siem/infrastructure/postgresql/")({
  component: Page,
});

function Page() {
  return (
    <div className="space-y-4 p-6">
      <Link to="/admin/siem" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Dashboard SIEM
      </Link>
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Badge variant="destructive" className="text-[10px]">SUPERADMIN</Badge>
        </div>
        <h1 className="text-2xl font-bold tracking-tight">PostgreSQL</h1>
        <p className="mt-1 text-sm text-muted-foreground">Primaire · Replicas · Locks · Slow query</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Primaire</div><div className="mt-1 text-2xl font-bold text-emerald-400">OK</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Replicas</div><div className="mt-1 text-2xl font-bold text-emerald-400">5</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Lag max</div><div className="mt-1 text-2xl font-bold text-emerald-400">12ms</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">TPS</div><div className="mt-1 text-2xl font-bold text-emerald-400">2 412</div></CardContent></Card>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Détails PostgreSQL
          </CardTitle>
          <CardDescription>Module opérationnel · branché à l'API unifiée v7.1</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Page détaillée du module PostgreSQL. Les métriques sont collectées via OpenTelemetry et agrégées via Prometheus.</p>
        </CardContent>
      </Card>
    </div>
  );
}
